export const ScreensList = '/screen/screens';
export const ScreenCreate = '/screen/screens/create';
export const ScreenEdit = '/screen/screens/edit';
export const ScreenCopy = '/screen/screens/copy';
export const TemplatesLink = '/screen/templates';

export const BranchesList = '/test/branches';
export const BranchesCreate = '/test/branches/create';

export const EditLink = '/test/links/edit';
export const CreateLink = '/test/links/create';
export const CopyLink = '/test/links/copy';
export const LinksList = '/test/links';
export const ActiveAppLinks = '/test/active-app-links';

export const CreateProductPlans = '/processing/product-plans/create';
export const ProductPlansList = '/processing/product-plans';
export const CampaignsList = '/processing/campaign';
export const CampaignEdit = '/processing/campaign/edit';

export const EditProductPlan = '/processing/product-plans/edit';
export const CopyProductPlan = '/processing/product-plans/copy';
export const ProductCodesLink = '/processing/product-codes';
export const VatRateList = '/processing/vat-rate';

export const AuditLogs = '/admin/audit-log';
export const ProjectsLink = '/admin/projects';
export const UsersLink = '/admin/users';
export const NotificationsLink = '/admin/notifications';
export const AddonsLink = '/admin/addons';
export const GlobalTestsLink = '/admin/global-tests';
export const GlobalTestCreate = '/admin/global-tests/create';
export const GlobalTestEdit = '/admin/global-tests/edit';

export const LocalizationsLink = '/content/localizations';
export const ThemesLink = '/content/themes';

export const LTVCoefficientList = '/analytics/ltv-coefficient';
export const AnalyticsTopicsLink = '/analytics/analytics-topics';
export const MicroTrendsLink = '/analytics/micro-trends';
